import {getFormData} from '../../../utilities/helper/formDataConvertor';
import request from '../../axios';

export const postPromotionCartToCart = async (
  payload: IPromotionCartToCartPayload,
) => {
  await request.post(
    `/api/v2/subscription/card-to-card-promotion`,
    getFormData(payload as unknown as {[name: string]: string | Blob}),
    {headers: {'content-type': 'multipart/form-data'}},
  );
};
